import { toast } from "react-toastify";
import { MessageToast, MessageToastProps } from "./MessageToast";

export const messageToast = (props: MessageToastProps) =>
  toast(<MessageToast {...props} />, {
    autoClose: 5000,
    position: "bottom-center",
    closeButton: true,
    hideProgressBar: true,
  });
